import React from 'react';
import {Route, Redirect} from 'react-router-dom';
import {connect} from 'react-redux';
import Chat from '../chat/Chat';
import Users from '../users/Users';
import User from '../users/User';
import Profile from '../profile/Profile';
import Clients from '../clients/Clients';
import Settings from '../settings/Settings';
import Mailing from '../mailing/Mailing';
import {roleAdmin} from "../../constants";
import GetcourseData from '../getcourse_data/GetcourseData';
import GetcourseDataItem from '../getcourse_data/GetcourseDataItem';

import ShiftControl from '../shift_control/ShiftControl';
import ResponseTime from '../response_time/ResponseTime';
import Roles from "../role/Roles";
import Role from '../role/Role';
import Permissions from '../role/Permissions';
import Permission from '../role/Permission';
import RolePermission from '../role/RolePermission';
import Triggers from '../triggers/Triggers';
import Trigger from '../triggers/Trigger';
import Faq from '../faq/Faq';
import DichatGroups from '../dichat_groups/DichatGroups';
import Materials from '../materials/Materials';
import FaqCategories from '../faq/FaqCategories';
import FaqSettings from '../faq/FaqSettings';

function PrivateRoutes(props) {
  return <React.Fragment>
    <PrivateRoute authorized={props.authorized} exact path="/" component={() => props.role_id === roleAdmin ? <Users/> : <Chat/>}/>
    <PrivateRoute authorized={props.authorized} path="/users" component={() => <Users/>}/>
    <PrivateRoute authorized={props.authorized} path="/user/:id" component={() => <User/>}/>
    <PrivateRoute authorized={props.authorized} path="/profile" component={() => <Profile/>}/>
    <PrivateRoute authorized={props.authorized} path="/clients" component={() => <Clients/>}/>
    <PrivateRoute authorized={props.authorized} path="/settings" component={() => <Settings/>}/>
    <PrivateRoute authorized={props.authorized} path="/mailings" component={() => <Mailing/>}/>
    <PrivateRoute authorized={props.authorized} path="/getcourse_data" component={() => <GetcourseData/>}/>
    <PrivateRoute authorized={props.authorized} path="/getcourse_data_item/:id" component={() => <GetcourseDataItem/>}/>
    <PrivateRoute authorized={props.authorized} path="/dialog/:client_id" component={() => <Chat/>}/>
    <PrivateRoute authorized={props.authorized} path="/c/:client_id" component={() => <Chat/>}/>
    <PrivateRoute authorized={props.authorized} path="/shift_control" component={() => <ShiftControl/>}/>
    <PrivateRoute authorized={props.authorized} path="/response_time" component={() => <ResponseTime/>}/>
    <PrivateRoute authorized={props.authorized} path="/roles" component={() => <Roles/>}/>
    <PrivateRoute authorized={props.authorized} path="/role/:id" component={() => <Role/>}/>
    <PrivateRoute authorized={props.authorized} path="/permissions" component={() => <Permissions/>}/>
    <PrivateRoute authorized={props.authorized} path="/permission/:id" component={() => <Permission/>}/>
    <PrivateRoute authorized={props.authorized} path="/role-permission/:id" component={() => <RolePermission/>}/>
    <PrivateRoute authorized={props.authorized} path="/triggers" component={() => <Triggers/>}/>
    <PrivateRoute authorized={props.authorized} path="/trigger/:id" component={() => <Trigger/>}/>
    <PrivateRoute authorized={props.authorized} path="/faq-categories" component={() => <FaqCategories/>}/>
    <PrivateRoute authorized={props.authorized} path="/faq-settings" component={() => <FaqSettings/>}/>
    <PrivateRoute authorized={props.authorized} exact path="/faq/:categoryId" component={() => <Faq/>}/>
    <PrivateRoute authorized={props.authorized} exact path="/faq" component={() => <Faq/>}/>
    <PrivateRoute authorized={props.authorized} path="/dichat-groups" component={() => <DichatGroups/>}/>
    <PrivateRoute authorized={props.authorized} path="/materials" component={() => <Materials/>}/>

  </React.Fragment>;
}

function PrivateRoute({component: Component, authorized, ...rest}) {
  return <Route
    {...rest}
    render={(props) => authorized
      ? <Component {...props} />
      : <Redirect to={{pathname: '/login', state: {from: props.location}}}/>}
  />;
}

const mapStateToProps = (state) => {
  return {
    authorized: !!state.user.profile.token,
    role_id: state.user.profile.role_id
  };
};

export default connect(mapStateToProps)(PrivateRoutes)
